import { possibleTipAmountsTuple } from "../services/types";

export const POSSIBLE_TIP_AMOUNTS: possibleTipAmountsTuple = [0, 5, 10, 15, 20, 25, 30, 35, null];
